import * as consts from "./play/const";
import ToyStyle from "./play/ToyStyle";
import {LanguageService} from "./play/Lang";

const { regClass, property } = Laya;

@regClass('AYxARGlSR--hHraDgZK9Nw')
export class DataCenter {
    public static readonly instance: DataCenter = new DataCenter();
    public user_name: string = "localuser";
    public user_pic: string = "null";

    public level_id: number = 0;
    public level_info: number[] = null;
    public level_mode: number = consts.MODE_COMMON;
    public all_levels: any[] = [];
    public level_data: any = 0;

    public special_data: any[] = [];
    public block_data: any[] = [];
    public toy_style: ToyStyle[] = [];
    public free_mode: boolean = false;
    public play_times: number = 0;
    public block_tips:boolean = true;
    
    getLevelData(level_id: number) {
        let max = 24
        while(level_id > max)
            level_id -= 20;
        return this.all_levels[level_id - 1];
    }

    initSpecialData(data: any[]) {
        this.special_data = data;
        new LanguageService();
                
        this.toy_style.push(new ToyStyle());
        this.toy_style.push(new ToyStyle(0));
        this.toy_style.push(new ToyStyle(2));
        this.toy_style.push(new ToyStyle(3));
        this.toy_style.push(new ToyStyle(-1, 0));
        this.toy_style.push(new ToyStyle(-1, 1));
        this.toy_style.push(new ToyStyle(-1, 2));
        this.toy_style.push(new ToyStyle(-1, 3));
        this.toy_style.push(new ToyStyle(-1, 4));
    }

    private screen_bg: Laya.Image = null;

    setScreenBg(img: Laya.Image) {
        this.screen_bg = img;
    }

    adjustScreen(root:Laya.Sprite) {
        let screen = root.parent;
        let stage_w = Laya.stage.width;
        let stage_h = Laya.stage.height;
        let ratio = stage_w / stage_h;
        let exp_ratio = 720/1280;
        if(ratio > exp_ratio) {
            let exp_w = stage_h * exp_ratio;
            root.width = exp_w;
            root.height = stage_h;
            root.x = (stage_w - exp_w) / 2;
            root.y = 0;

            let img = new Laya.Image();
            img.skin = this.screen_bg.skin;
            img.sizeGrid = "0,0,0,0,1"
            img.width = root.x;
            img.height = stage_h;
            img.x = 0;
            img.y = 0;
            screen.addChild(img);

            img = new Laya.Image();
            img.skin = this.screen_bg.skin;
            img.sizeGrid = "0,0,0,0,1"
            img.width = root.x;
            img.height = stage_h;
            img.x = root.x + root.width;
            img.y = 0;
            screen.addChild(img);

            let w = 10
            let color = "#251c11";

            let box = new Laya.Box();
            box.bgColor = color;
            box.width = w;
            box.height = stage_h;
            box.x = root.x - w;
            box.y = 0;
            screen.addChild(box);

            box = new Laya.Box();
            box.bgColor = color;
            box.width = w;
            box.height = stage_h;
            box.x = root.x + root.width;
            box.y = 0;
            screen.addChild(box);
        } else {
            root.width = 720;
            root.height = 720 / ratio;
            root.x = 0;
            root.y = 0;
            let scale = stage_w / 720;
            root.scaleX = scale;
            root.scaleY = scale;
        }

    }

    doGenSpecial(weights:number[]):number {
        let whole = 0;
        for(let item of weights) {
            whole += item;
        }
        let r = Math.floor(Math.random() * whole);
        let offset = 0;
        for (let i = 0; i < weights.length; i++) {
            offset += weights[i];
            if(r < offset) {
                return i;
            }
        }
        return 0;
    }

    genSpecialToy(type: number, special_ids: number[]): number {
        for(let id of special_ids) {
            if(id == 0) {
                continue;
            }
            let item = this.special_data.find((item) => {
                return item[0] == id;
            });
            if(item[1] == type)
            {
                return this.doGenSpecial(item[2]);
            }
        }
        return 0;
    }

    getStocks(special_ids: number[]): number[] {
         for(let id of special_ids) {
            if(id == 0) {
                continue;
            }
            let item = this.special_data.find((item) => {
                return item[0] == id;
            });
            if(item[1] == consts.SPECIAL_TYPE_STOCK)
            {
                return item[2];
            }
        }
        return [];
    }


    initBlockData(data: any[]) {
        this.block_data = data;
    }

    getBlockData(id: number): number[] {
        let item = this.block_data.find((item) => {
            return item[0] == id;
        });
        if(item) {
            return item[1];
        }
        return null;
    }

    getClipXByBlock(id: number): number[] {
        let item = this.getBlockData(id);
        if(item) {
            let ret:number[] = []
            for(let i = 0; i < item.length; i += 2) {
                this.addClip(ret, item[i]);
            }
            return ret;
        }
        return null;
    }

    addClip(clips: number[], x:number) {
        for(let i = 0; i < clips.length; i += 2) {
            if( x > clips[i] && x < clips[i + 1]) {
                return
            }
        }
        x -= consts.HALF_TOY_IMAGE
        clips.push(x - consts.BLOCK_SIZE);
        clips.push(x + consts.BLOCK_SIZE);
    }

    curProvince(level: number) :number {
        let prov = this.all_levels[level][4];
        for(let k = level - 1; k >= 0; k --)
        {
            let item = this.all_levels[k];
            if(item[4] != prov) {
                return k + 1;
            }
        }
        return 0;
    }
    nextProvince(level: number) :number {
        let prov = this.all_levels[level][4];
        for(let k = level + 1; k <= this.all_levels.length; k ++)
        {
            let item = this.all_levels[k];
            if(item[4] != prov) {
                return k;
            }
        }
        return 0;
    }

}